import { z } from "zod"
import LivenessSessionStatus from "../../domain/LivenessSessionStatus.js"
import { FeatureFlagSchema } from "../shared/FeatureFlag.js"
import { UUIDv4Schema } from "../shared/UUIDv4.js"

/**
 * @description
 *	The schema of {@link FaceSignatureCompletionQueryParameters} type.
 *
 * @remarks
 *	The integration identifier is optional, because the result page has to
 *	keep working, neutral, for a redirection built before the branding
 *	existed.
 */
export const FaceSignatureCompletionQueryParametersSchema = z.object({
	integrationId: UUIDv4Schema.optional(),
	isLive: FeatureFlagSchema,
	status: z.enum(LivenessSessionStatus)
})

/**
 * @description
 *	The signed URI query parameters of a Face Signature process.
 */
export type FaceSignatureCompletionQueryParameters = z.infer<typeof FaceSignatureCompletionQueryParametersSchema>
